import { render, staticRenderFns } from "./EntryBtn.vue?vue&type=template&id=b48e2fae&scoped=true&"
import script from "./EntryBtn.vue?vue&type=script&lang=js&"
export * from "./EntryBtn.vue?vue&type=script&lang=js&"
import style0 from "./EntryBtn.vue?vue&type=style&index=0&id=b48e2fae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48e2fae",
  null
  
)

export default component.exports